<template>
  <!-- 登录 or 注册 -->
  <el-dialog v-model="registerVisible" :width="isMobile ? '90%' : 500" @close="closeFunc('register')">
    <template #title>
      <div class="status">
        <el-radio-group v-model="status">
          <el-radio-button :label="0">登录</el-radio-button>
          <el-radio-button :label="1">注册</el-radio-button>
        </el-radio-group>
      </div>
    </template>
    <div class="loginModal">
      <el-form ref="registerFormRef" :model="registerFormData" status-icon :rules="rules" :label-width="isMobile ? '0.8rem' : '0.9rem'">
        <el-form-item label="邮箱：" prop="email">
          <el-input id="email" v-model="registerFormData.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item v-if="status === 0" label="验证码：" prop="code">
          <el-input id="code" v-model="registerFormData.code" placeholder="请输入验证码" style="width: 70%"></el-input>
          <img class="code" :src="codeUrl" @click="getCode" />
        </el-form-item>
        <el-form-item v-else-if="status === 1" label="校验码：" prop="code">
          <el-input id="code" v-model="registerFormData.code" placeholder="请输入邮箱验证码" style="width: 70%"></el-input>
          <p v-if="timer > 0" class="send" style="color: #999">{{ timer }}秒后重新发送</p>
          <p v-else class="send" @click="sendCode1">发送邮箱验证码</p>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input
            id="password"
            v-model="registerFormData.password"
            type="password"
            autocomplete="off"
            placeholder="字母开头,包含字母数字,长度5-20之间"
            :style="`width: ${status === 0 ? 70 : 100}%`"
          ></el-input>
          <p v-if="status === 0" class="forget" @click.stop="forgetFunc">忘记密码</p>
        </el-form-item>
        <div v-show="false">
          <el-form-item label="uuid：" prop="uuid">
            <el-input id="uuid" v-model="registerFormData.uuid" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" size="medium" @click.stop="closeFunc('register')">取消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="
            () => {
              status === 0 ? LoginFunc() : registerFunc();
            }
          "
          >{{ status === 0 ? '登录' : '注册' }}</el-button
        >
      </span>
    </template>
  </el-dialog>
  <!-- 忘记密码弹窗 -->
  <el-dialog v-model="forgetVisible" title="密码重置" :width="isMobile ? '90%' : 500" @close="closeFunc('forget')">
    <div class="forgetModal">
      <el-form ref="forgetFormRef" :model="forgetFormData" status-icon :rules="rules" :label-width="isMobile ? '0.8rem' : '0.9rem'">
        <el-form-item label="邮箱：" prop="email">
          <el-input id="email" v-model="forgetFormData.email" placeholder="请输入邮箱" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item label="校验码：" prop="code">
          <el-input id="code" v-model="forgetFormData.code" placeholder="请输入邮箱验证码" style="width: 60%"></el-input>
          <p v-if="timer > 0" class="send" style="color: #999">{{ timer }}秒后重新发送</p>
          <p v-else class="send" @click="sendCode">发送邮箱验证码</p>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPwd">
          <el-input
            id="newPwd"
            v-model="forgetFormData.newPwd"
            type="password"
            autocomplete="off"
            placeholder="长度5-20之间，字母开头，包含字母数字"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <div v-show="false">
          <el-form-item label="uuid：" prop="uuid">
            <el-input id="uuid" v-model="forgetFormData.uuid" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeFunc('forget')">取消</el-button>
        <el-button type="primary" size="medium" @click="changePassword">修改密码</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { onMounted, reactive, toRefs, watch, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import UserApi from '../../service/api/user';
import { validateEmail, validatePassword } from '../../utils/operation';
import { ElMessage } from 'element-plus';
import { aesEncrypt } from '../../service/crypto';

let timerout = null;

export default {
  name: 'LoginModal',
  components: {},
  props: {
    canRegister: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({
      status: 0, // 0登录，1注册，2找回密码
      registerVisible: true,
      registerFormData: {},
      registerFormRef: null,
      rules: {
        userName: [{ required: true, message: '用户名必填', trigger: 'change' }],
        password: [
          { required: true, message: '密码必填', trigger: 'change' },
          { validator: validatePassword, trigger: 'blur' },
        ],
        newPwd: [
          { required: true, message: '密码必填', trigger: 'change' },
          { validator: validatePassword, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '邮箱必填', trigger: 'change' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        code: [{ required: true, message: '验证码必填', trigger: 'change' }],
      },
      codeUrl: '',
      forgetVisible: false,
      forgetFormRef: null,
      forgetFormData: {},
      timer: 0,
    });
    watch(
      () => state.status,
      (nVal) => {
        state.registerVisible = nVal === 0 || nVal === 1;
        state.forgetVisible = nVal === 2;
        nVal === 0 && getCode();
      },
    );

    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const getCode = async () => {
      const validateCode = await UserApi.code();
      state.codeUrl = 'data:image/gif;base64,' + validateCode.img;
      state.registerFormData.uuid = validateCode.uuid;
    };
    const forgetFunc = () => {
      state.status = 2;
      state.registerFormRef.resetFields();
    };
    const closeFunc = (from) => {
      if (from === 'register') {
        state.registerVisible = false;
        state.registerFormRef && state.registerFormRef.resetFields();
      }
      if (from === 'forget') {
        state.forgetVisible = false;
        state.forgetFormRef && state.forgetFormRef.resetFields();
      }
      store.commit('SET_SHOWLOGIN', state.registerVisible || state.forgetVisible);
      store.state.showLogin;
    };
    const LoginFunc = () => {
      state.registerFormRef.validate(async (valid) => {
        if (valid) {
          const formData = {
            ...state.registerFormData,
            password: aesEncrypt(state.registerFormData.password),
          };
          try {
            const res = await UserApi.login(formData);
            ElMessage.success('登录成功');
            store.commit('SET_SHOWLOGIN', false);
            store.commit('SET_TOKEN', res.access_token);
            localStorage.setItem('guide', 1);
            setTimeout(() => location.reload(), 300);
          } catch {
            return getCode();
          }
        } else {
          return false;
        }
      });
    };
    const registerFunc = () => {
      if (!props.canRegister) {
        return ElMessage.error('报名已截止，不能注册');
      }
      state.registerFormRef.validate(async (valid) => {
        if (valid) {
          const formData = {
            ...state.registerFormData,
            password: aesEncrypt(state.registerFormData.password),
          };
          try {
            const res = await UserApi.register(formData);
            ElMessage.success('注册成功');
            store.commit('SET_SHOWLOGIN', false);
            store.commit('SET_TOKEN', res.access_token);
            setTimeout(() => location.reload(), 300);
          } catch (e) {
            console.error('注册失败', e);
          }
        } else {
          return false;
        }
      });
    };
    onMounted(getCode);

    const sendCode1 = async () => {
      if (!props.canRegister) {
        return ElMessage.error('报名已截止，不能注册');
      }
      state.registerFormRef.validateField('email', async (errMsg) => {
        if (!errMsg) {
          const res = await UserApi.sendRegisterCode({
            email: state.registerFormData.email,
          });
          state.timer = res.expire;
          clearInterval(timerout);
          timerout = setInterval(() => {
            if (state.timer === 0) {
              return clearInterval(timerout);
            }
            state.timer = state.timer - 1;
          }, 1000);
          state.registerFormData.uuid = res.uuid;
        }
      });
    };
    // 找回密码
    const sendCode = async () => {
      state.forgetFormRef.validateField('email', async (errMsg) => {
        if (!errMsg) {
          const res = await UserApi.sendEmailCode({
            email: state.forgetFormData.email,
          });
          state.timer = res.expire;
          clearInterval(timerout);
          timerout = setInterval(() => {
            if (state.timer === 0) {
              return clearInterval(timerout);
            }
            state.timer = state.timer - 1;
          }, 1000);
          state.forgetFormData.uuid = res.uuid;
        }
      });
    };
    const changePassword = async () => {
      state.forgetFormRef.validate(async (valid) => {
        if (valid) {
          const formData = {
            ...state.forgetFormData,
          };
          try {
            await UserApi.changePassword({
              hcp: aesEncrypt(JSON.stringify(formData)),
            });
            ElMessage.success('修改成功，请重新登录');
            state.status = 0;
          } catch {
            console.error('修改密码失败');
          }
        } else {
          return false;
        }
      });
    };
    const isMobile = computed(() => store.state.isMobile);

    return {
      ...toRefs(state),
      registerFunc,
      LoginFunc,
      closeFunc,
      getCode,
      forgetFunc,
      route,
      router,
      sendCode1,
      sendCode,
      changePassword,
      isMobile,
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../style/func.scss';
.status {
  text-align: center;
}
.forget {
  float: right;
  color: #999;
  text-align: right;
  line-height: rem(40px);
  cursor: pointer;
}
.code {
  float: right;
  width: rem(100px);
  margin-top: 1px;
  margin-left: rem(4px);
}
.send {
  float: right;
  width: rem(104px);
  color: #409eff;
  cursor: pointer;
  margin-left: rem(4px);
}

@media screen and (max-width: 600px) {
  .code {
    width: rem(80px);
  }
  .send {
    font-size: rem(12px);
  }
  .loginModal,
  .forgetModal {
    margin-left: rem(-20px);
    :deep(.el-form-item__label) {
      padding: 0;
    }
  }

  :deep(.el-form-item__content) {
    display: flex;
    justify-content: space-between;
  }
}
</style>
